import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logoMark from '../../assets/brand/logo-mark-trimmed.png';

const NAV_ITEMS = [
    { path: '/admin/dashboard',   label: 'ダッシュボード', icon: DashboardIcon },
    { path: '/admin/projects',    label: '案件管理',       icon: FolderIcon },
    { path: '/admin/payouts',     label: '振込管理',       icon: CreditIcon },
    { path: '/admin/contractors', label: '業者管理',       icon: UsersIcon },
];

function DashboardIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
        </svg>
    );
}
function FolderIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2h5l2 3h9a2 2 0 0 1 2 2z" />
        </svg>
    );
}
function CreditIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
        </svg>
    );
}
function UsersIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    );
}

const AdminLayout = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem('admin_access_token')) {
            navigate('/admin/login');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('admin_access_token');
        navigate('/admin/login');
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f6f8' }}>
            {/* サイドバー */}
            <aside style={{ width: 220, background: '#141c3d', color: '#fff', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <div style={{ padding: '24px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <img src={logoMark} alt="" style={{ height: 24, display: 'block' }} />
                        <h1 style={{ fontSize: '1rem', fontWeight: 700, color: '#fff', margin: 0 }}>のりいれ三丁目</h1>
                    </div>
                    <p style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)', margin: '4px 0 0' }}>管理画面</p>
                </div>
                <nav style={{ flex: 1, padding: '16px 12px' }}>
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {NAV_ITEMS.map(item => {
                            const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
                            const Icon = item.icon;
                            return (
                                <li key={item.path}>
                                    <button
                                        onClick={() => navigate(item.path)}
                                        style={{
                                            width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                                            padding: '10px 14px', borderRadius: 6, border: 'none', cursor: 'pointer',
                                            fontSize: '0.875rem', fontWeight: isActive ? 600 : 400, textAlign: 'left',
                                            background: isActive ? '#005c53' : 'transparent',
                                            color: isActive ? '#fff' : 'rgba(255,255,255,0.65)',
                                            transition: 'background 0.15s',
                                        }}
                                    >
                                        <Icon />{item.label}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
                {/* ログアウト */}
                <div style={{ padding: '16px 12px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                    <button
                        onClick={handleLogout}
                        style={{
                            width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                            padding: '10px 14px', borderRadius: 6, border: 'none', cursor: 'pointer',
                            fontSize: '0.875rem', textAlign: 'left',
                            background: 'transparent', color: 'rgba(255,255,255,0.5)',
                        }}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                        ログアウト
                    </button>
                </div>
            </aside>

            {/* メインコンテンツ */}
            <main style={{ flex: 1, overflow: 'auto' }}>
                {children}
            </main>
        </div>
    );
};

export default AdminLayout;
